import {Block} from './Block';
import day from './day.svg'
import devices from './devices.svg'
import money from './money.svg'

import cls from './Advantages.module.scss'

export const Advantages = () => (
    <div className={cls.instruction}>
        <h2>Наши преимущества</h2>
        <div className={cls.blocks}>
            <Block img={devices} title={'С любого устройства'} text={'Быстрый доступ к займу с любого устройства'}/>
            <Block img={day} title={'Работаем 24/7'} text={'Мы доступны для вас в любое время дня и ночи'}/>
            <Block img={money} title={'Моментальное решение'} text={'Быстрый способ решить проблему'}/>
        </div>
    </div>
)